// extracted by extract-css-chunks-webpack-plugin
module.exports = {"storeInfoWrapper":"FamI-","storeName":"OwNke","ulStoreTimeWrap":"vQGxO","storeTime":"_32dCX","storeLinkBtn":"DVWef"};